import { Pagination } from '@/shared/constants/types'
import { GameType } from '@/entities/platforms/steam/types/types'
export type AuthParamsType = {
  init_data?: string
  device?: string
  timezone?: string
  phone?: string
}

export type UpdateUserSettingsParamsType = {
  token: string
  data: {
    key: string
    value: string | boolean | number
  }
}

export type Friend = {
  friend_tid: number
  username: string
  gamed_id: string
  gigi: number
  premium_level: number
  avatar: string
}

export type ReferralInfoType = {
  unclaimed: number
  unclaimed_expire_at: string
  claimed_total: number
  referred_level_1: number
  referred_level_2: number
  level_1_ref_ratio: number
  level_2_ref_ratio: number
}

export type FriendsListResponse = {
  pagination: Pagination
  data: Friend[]
}

type SteamItemType = {
  id: number
  game_id: number
  name: string
  price: number
  icon_url: string
  is_saling?: boolean
}

export type EGSGame = {
  name: string
  img_url: string
  achievements_total: number
  achievements_done: number
  xp_total: number
  xp_earned: number
}

export type EpicUserData = {
  username: string
  total_xp: number
  total_achievements: number
  total_value_usd: number
  games: EGSGame[]
  epic_gigi: number
  updating: boolean
  scoring_diff: {
    games_owned: number
    games_owned_token: number
    achievements: number
    achievements_token: number
    xp: number
    xp_token: number
  }
}

export type ScoringDiffType = {
  games_owned: number
  total_hours: number
  inventory_price: number
  most_expensive_new_item: {
    id: number
    game_id: number
    name: string
    price: number
    icon_url: string
  }
  most_expensive_new_item_value: number
}

// may extend on more settings
export type UserSettingsType = {
  legacy_lootboxes_diff?: number | string // это разница в начисленных поинтах (сколько доначисленно за лутбоксы)
  tonWalletConnected?: boolean
  showedRecalculatingView?: boolean
  farcana_expires_in?: number
  farcana_jwt?: string
  farcana_refresh?: string
  is_private?: boolean
  friends_pressed?: number
  isOnboarded?: boolean
  claimedFriendsRewards?: boolean
  [key: string]: boolean | number | string | undefined
}

export enum PremiumLevel {
  UNSUBSCRIBED = 0,
  PLUS = 1,
  PLATINUM = 2,
}

export enum SettingsEvents {
  PRIVATE_ACCOUNT = 'is_private',
  FRIENDS_PRESSED = 'friends_pressed',
  HAS_CLAIMED_FRIEND_REWARD = 'claimedFriendsRewards',
}

// export type GetProfileResponseType = {
//   user: {
//     tid: number
//     first_name: string
//     last_name: string
//     username: string
//     language_code: string
//     is_premium: true
//     device: string
//     timezone: string
//     phone: string
//     photo_url: string
//     steam_id: number
//     token_value: number

//     ref_url: string
//     ref_url_story: string
//     previous_token_value_total: number
//     gamed_premium_until: string | null
//     gigi_index: number
//     farcana_gigi: number
//     epic_id: string
//     epic_token_value: number
//     level_premium: number | null

//     steam_update_in_progress: boolean
//     next_steam_update_unlocked: string

//     epic_update_in_progress: boolean
//     next_epic_update_unlocked: string
//   }
//   steam_data: {
//     profile: {
//       name: string
//       photo_url: string
//       games_count: number
//       total_hours: number
//       items_count: number
//       total_value_usd: number
//       diff_games_count: number
//       diff_total_hours: number
//       diff_items_count: number
//       diff_total_value_usd: number
//       inventory_price_usd: number
//       registration_date: Date

//       privacy_info: {
//         profile_private: boolean
//       }
//     }

//     top_items: SteamItemType[]
//     games: GameType[]
//     scoring_diff: ScoringDiffType
//   }
//   epic_data: EpicUserData | null
//   referral_info: ReferralInfoType
//   settings: UserSettingsType
// }

export type UserInfo = {
  games: GameType[]
  gigi: number
  avatar: string
  is_friend: boolean
  is_private: boolean
  premium_level: number
  stats: {
    daily_playtime: number
    games_owned: number
    items_owned: number
    total_accounts_value: number
    total_assets_purchased: number
    total_hours_played: number
  }
  username: string
}

export type TGAccountDataType = {
  token: string
  token_expiration: number
  user: {
    tid: number
    first_name: string
    last_name: string
    username: string
    language_code: string
    is_premium: boolean
    device: string
    timezone: string
    phone: string
    photo_url: string
    steam_id?: number | null
  }
}

export type SteamUserDataType = {
  itemsList: SteamItemType[] | null
  gamesList: GameType[] | null
  scoring_diff: ScoringDiffType | null
  userData: {
    epic_token_value: number | null
    id: number | null
    name: string | null
    photoUrl: string | null
    gamed_id: string | null
    totalValue: number | null
    epicTotalValue: number | null
    gamesOwned: number | null
    totalHoursPlayed: number | null
    itemsOwned: number | null
    diff_games_count: number | null
    diff_total_hours: number | null
    diff_items_count: number | null
    diff_total_value_usd: number | null
    inventoryPrice: number | null
    accountAge: number | null
    favoriteGame: string | null
    nextSteamUpdateUnlockDate: string | null
    steam_update_in_progress: boolean
    tokenValue: number | null
    steamId: number | null
    ref_url: string | null

    gamed_premium_until: string | null
    level_premium: number | null

    ref_url_story: string | null
    profile_private: boolean
    previous_token_value_total: number
    registredAt: Date | null
    farcana_gigi: number | null
    gigi_index: number | null
    epic_id: string | null
    epic_update_in_progress: boolean
    next_epic_update_unlocked: string | null
  }
  referal_info: ReferralInfoType
  settings: UserSettingsType
}

export type UserByGamedId = {
  friend_tid: number
  premium_level: number
  username: string
  avatar: string
  gigi: number
  gamed_id: string
  is_friend: boolean
}
